
import SignUpForm from '../components/SignupFormComponent/Signup.component';

const SignUpPage = () => {

    return (
        <SignUpForm />
    )
}

export default SignUpPage